import {useSelector} from 'react-redux';

import aiAssistantSessionService from '../services/aiAssistant/aiAssistantSessionService';
import {
    selectAiAssistantProposal,
    selectAiAssistantState,
    selectIsAiAssistantWidgetOpened,
} from '../state/selectors/aiAssistant';
import {clearProposal} from '../state/slice/aiAssistant';
import {dispatch} from '../state/store';

// Opening isn't here - it goes through aiAssistantAccessService and its preconditions
const useAiAssistantWidget = () => {
    const isWidgetOpened = useSelector(selectIsAiAssistantWidgetOpened);
    const assistantState = useSelector(selectAiAssistantState);
    const proposal = useSelector(selectAiAssistantProposal);

    const closeWidget = () => aiAssistantSessionService.endSession();
    const confirmProposal = (settingName) => aiAssistantSessionService.confirmProposal(settingName);
    // Auto-close is client-side, after `autoCloseMs`
    const dismissProposal = () => dispatch(clearProposal());

    return {isWidgetOpened, assistantState, proposal, closeWidget, confirmProposal, dismissProposal};
};

export default useAiAssistantWidget;
